import { createReducer } from '@reduxjs/toolkit';
import get from 'lodash/get';
import reduce from 'lodash/reduce';
import replace from 'lodash/replace';

import { ActionFailureType, ActionSuccessType, GET_DESIGN_PATHS } from 'constants/redux-actions';

const initState = {
  loading: true,
  paths: {},
};

const designPathsReducer = createReducer(initState, {
  [GET_DESIGN_PATHS]: (state) => ({ ...state, loading: true }),
  [ActionSuccessType(GET_DESIGN_PATHS)]: (_, action) => {
    const designPaths = get(action.payload, 'data', []);

    return {
      loading: false,
      paths: reduce(
        designPaths,
        (res, designPath) => ({
          ...res,
          [designPath.customPageId]: {
            ...designPath,
            pathPattern: designPath.rootSite
              ? designPath.path
              : replace(designPath.path, /^\/[^/]+/, (match) => `/:siteSlug(${match.slice(1)})`),
          },
        }),
        {},
      ),
    };
  },
  [ActionFailureType(GET_DESIGN_PATHS)]: () => ({ ...initState, loading: false }),
});

export default designPathsReducer;
